import { FC, PropsWithChildren } from 'react';
import { formatCodeName } from '../../../common/utils';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './AlgorithmTargetMappingTargetOptionLabel.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory(
  'algorithm-target-mapping-target-value',
);
addTranslations(translations);

export interface AlgorithmTargetMappingTargetOptionLabelProps
  extends PropsWithChildren {
  code: string;
  name: string;
  confidentialityStatus?: boolean;
}

export const AlgorithmTargetMappingTargetOptionLabel: FC<
  AlgorithmTargetMappingTargetOptionLabelProps
> = (props) => {
  const { confidentialityStatus = false, ...rest } = props;
  const { t } = useTranslation();

  return t(confidentialityStatus ? 'target.conf' : 'target.name', {
    codeName: formatCodeName(rest),
  });
};
